import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { newsAPI } from '../services/api';
import './News.css';

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const res = await newsAPI.getList({ limit: 20 });
      setNewsList(res.data || []);
    } catch (error) {
      setNewsList([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('zh-CN');
  };

  return (
    <div className="news-page">
      {/* Hero Section */}
      <section className="news-hero page-hero hero-tone-violet">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <span className="hero-eyebrow">产品动态 · 行业洞察</span>
          <h1 className="page-title">信息与资源</h1>
          <p className="page-subtitle">了解产品动态与行业洞察</p>
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="container">
          <div className="news-tabs">
            <Link to="/news" className="news-tab active">信息发布</Link>
            <Link to="/resources" className="news-tab">资源下载</Link>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="content-section">
        <div className="container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>加载中...</div>
          ) : (
            <div className="news-list">
              {newsList.map((news, index) => (
                <Link key={news._id} to={`/news/${news._id}`} className="news-card" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="news-meta">
                    <span className="news-tag">{news.tag}</span>
                    <span className="news-date">{formatDate(news.date)}</span>
                  </div>
                  <h3 className="news-title">{news.title}</h3>
                  <p className="news-summary">{news.summary}</p>
                </Link>
              ))}
              {newsList.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                  暂无信息
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="news-cta">
        <div className="container">
          <h2>获取最新动态</h2>
          <p>关注公众号，获取产品更新与行业洞察</p>
          <a href="/contact" className="btn btn-primary btn-lg">联系我们</a>
        </div>
      </section>
    </div>
  );
};

export default News;